'use client';

import { useEffect } from 'react';

export default function ContactPixelEvents() {
  useEffect(() => {
    // Meta Pixel - Contact Page View
    if (typeof window !== 'undefined' && (window as any).fbq) {
      (window as any).fbq('trackCustom', 'ContactPageView');
    }
  }, []);

  return null;
}
